import React from 'react';
import ProfileOrder from './ProfileOrder';
import './../../../Styles/Main/ProfilePage/ProfileCurrentTab.scss';
import { useContext } from 'react';
import { SelectedBike } from '../../../Constant/context';

function ProfileCurrentTab(props) {

   const { selectedDateGlobal, selectedBikeGlobal, arrayOfBikes, setArrayOfBikes, orderedDateGlobal, setOrderedDateGlobal } = useContext(SelectedBike)

   const statusColor = ['1px solid #008900', '#008900'];

   return (
      <div className="currentTab__body">
         <div className="currentTab__header">
            <div className="currentTab__signature signature">Type of rent</div>
            <div className="currentTab__signature signature">Date</div>
            <div className="currentTab__signature signature">Cost</div>
            <div className="currentTab__signature signature">Payment</div>
            <div className="currentTab__signature signature">Status</div>
         </div>
         <div className="currentTab__orders">
            {orderedDateGlobal.map((item, index) => (
               <ProfileOrder
                  key={index}
                  orderNum={`№00${25+index}`}
                  date={'2022.10.02'}
                  amountDays={item[0].amountDays}
                  startDate={item[0].startDate}
                  finishDate={item[0].finishDate}
                  sum={item[0].sumPrice}
                  payment={item[0].payment}
                  status={'In proccess'}
                  statusColor={statusColor[1]}
                  statusBorder={statusColor[0]}
                  delivery={item[0].delivery}
                  typeRent={item[0].typeRent}
                  orderedBikes={item[1]}
               />
            ))}
            
         </div>
      </div>
   );
}
export default ProfileCurrentTab;